import { RESULT_MORE } from "./const";

function action(count) {
  return {
    type: RESULT_MORE,
    count,
  };
}

export default action;
